import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const SECTIONS = [
  {
    title: "1. Anbieter",
    body: [
      "Anbieter der App BriefAssist ist:",
      "cc-onlinekurse",
      "Inhaber: Claudiu Ciobotaru",
      "Gestütring 3",
      "85435 Erding",
      "Deutschland",
      "E-Mail: info@cc-onlinekurse.de",
    ],
  },
  {
    title: "2. Geltungsbereich",
    body: [
      "Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der App und Web-App BriefAssist sowie für alle darüber angebotenen kostenpflichtigen und kostenlosen Leistungen.",
      "Sie gelten insbesondere für die Registrierung, die Nutzung der Dokumentenanalyse sowie für den Abschluss von Abonnements oder sonstigen kostenpflichtigen Leistungen.",
      "Abweichende Bedingungen des Nutzers gelten nur, wenn ihnen der Anbieter ausdrücklich zugestimmt hat.",
    ],
  },
  {
    title: "3. Leistungsbeschreibung",
    body: [
      "BriefAssist ermöglicht Nutzern insbesondere, Dokumente und Briefe hochzuladen oder anderweitig zur Analyse bereitzustellen.",
      "Die App kann unter anderem:",
    ],
    list: [
      "Inhalte von Dokumenten erkennen und zusammenfassen,",
      "wichtige Informationen und Fristen hervorheben,",
      "Texte verständlich erklären,",
      "Inhalte in andere Sprachen übersetzen oder erklären,",
      "Hinweise zu möglichen nächsten Schritten geben.",
    ],
    footer: [
      "Die Auswertung erfolgt teilweise automatisiert und kann insbesondere auf Technologien der künstlichen Intelligenz beruhen.",
      "Ein Anspruch auf eine bestimmte Verfügbarkeit einzelner Funktionen besteht nur, soweit dies ausdrücklich Bestandteil eines kostenpflichtigen Tarifs ist.",
    ],
  },
  {
    title: "4. Keine Rechts-, Steuer- oder Finanzberatung",
    body: [
      "BriefAssist dient der Unterstützung beim Verständnis von Dokumenten.",
      "Die durch die App bereitgestellten Zusammenfassungen, Übersetzungen, Erläuterungen, Hinweise und Handlungsvorschläge stellen insbesondere keine Rechtsberatung, Steuerberatung, Finanzberatung oder sonstige individuelle professionelle Beratung dar.",
      "Bei rechtlich, finanziell oder anderweitig wesentlichen Entscheidungen sollte der Nutzer die Originalunterlagen prüfen und gegebenenfalls qualifizierte Fachpersonen, Behörden oder Beratungsstellen kontaktieren.",
      "Insbesondere bei Fristen, Zahlungsaufforderungen, Kündigungen, Mahnungen, gerichtlichen Schreiben oder behördlichen Bescheiden sollte sich der Nutzer nicht ausschließlich auf die Analyse durch BriefAssist verlassen.",
    ],
  },
  {
    title: "5. Registrierung und Nutzerkonto",
    body: [
      "Für bestimmte Funktionen kann die Einrichtung eines Nutzerkontos erforderlich sein.",
      "Der Nutzer ist verpflichtet, bei der Registrierung wahrheitsgemäße Angaben zu machen und seine Zugangsdaten vor dem Zugriff Dritter zu schützen.",
      "Eine Weitergabe von Zugangsdaten an unbefugte Dritte ist nicht gestattet.",
      "Der Nutzer ist für sämtliche Aktivitäten verantwortlich, die über sein Nutzerkonto vorgenommen werden, soweit er diese zu vertreten hat.",
    ],
  },
  {
    title: "6. Hochladen von Dokumenten",
    body: [
      "Der Nutzer darf nur Dokumente oder Inhalte hochladen, zu deren Nutzung und Verarbeitung er berechtigt ist.",
      "Der Nutzer verpflichtet sich insbesondere, keine Inhalte hochzuladen, deren Verarbeitung Rechte Dritter verletzt oder gegen geltendes Recht verstößt.",
      "Werden Dokumente mit personenbezogenen Daten Dritter hochgeladen, ist der Nutzer dafür verantwortlich, dass hierfür eine ausreichende rechtliche Grundlage besteht.",
      "Weitere Informationen zur Verarbeitung personenbezogener Daten ergeben sich aus der Datenschutzerklärung von BriefAssist.",
    ],
  },
  {
    title: "7. Automatisierte und KI-basierte Auswertung",
    body: [
      "Die Auswertung von Dokumenten kann ganz oder teilweise automatisiert und unter Einsatz künstlicher Intelligenz erfolgen.",
      "Trotz technischer Qualitätskontrollen können insbesondere folgende Fehler auftreten:",
    ],
    list: [
      "fehlerhafte Texterkennung,",
      "unvollständige Zusammenfassungen,",
      "falsche Interpretation von Inhalten,",
      "fehlerhafte Übersetzungen,",
      "falsch erkannte Beträge, Namen oder Fristen.",
    ],
    footer: [
      "Der Nutzer ist daher verpflichtet, wichtige Informationen mit dem Originaldokument abzugleichen.",
      "BriefAssist übernimmt keine Garantie dafür, dass automatisierte Ergebnisse vollständig, fehlerfrei oder für einen bestimmten Zweck geeignet sind.",
    ],
  },
  {
    title: "8. Kostenlose Leistungen",
    body: [
      "BriefAssist kann einzelne Funktionen kostenlos zur Verfügung stellen.",
      "Der Umfang kostenloser Leistungen kann jederzeit angepasst, eingeschränkt oder erweitert werden, soweit dies für den Nutzer zumutbar ist.",
      "Ein Anspruch auf die dauerhafte kostenlose Bereitstellung bestimmter Funktionen besteht nicht.",
    ],
  },
  {
    title: "9. Kostenpflichtige Leistungen und Abonnements",
    body: [
      "BriefAssist kann kostenpflichtige Tarife und Abonnements anbieten.",
      "Vor Abschluss eines kostenpflichtigen Vertrags werden dem Nutzer insbesondere folgende Informationen angezeigt:",
    ],
    list: [
      "Preis,",
      "Abrechnungszeitraum,",
      "Leistungsumfang,",
      "Vertragslaufzeit,",
      "gegebenenfalls automatische Verlängerung,",
      "Kündigungsbedingungen.",
    ],
    footer: [
      "Die jeweils auf der Bestellseite angegebenen Preise gelten einschließlich der gesetzlich anfallenden Umsatzsteuer, sofern diese anfällt und nicht anders ausgewiesen ist.",
    ],
  },
  {
    title: "10. Vertragsschluss",
    body: [
      "Die Darstellung kostenpflichtiger Leistungen innerhalb der App stellt noch kein verbindliches Vertragsangebot dar.",
      "Der Nutzer gibt durch Betätigung des entsprechend gekennzeichneten Bestellbuttons ein verbindliches Angebot zum Abschluss eines Vertrags ab.",
      "Der Vertrag kommt zustande, sobald die Bestellung bestätigt oder die kostenpflichtige Leistung freigeschaltet wird.",
    ],
  },
  {
    title: "11. Zahlungsabwicklung",
    body: [
      "Die Zahlungsabwicklung kann über externe Zahlungsdienstleister, insbesondere Stripe, erfolgen.",
      "Für die Zahlungsabwicklung können ergänzend die Bedingungen des jeweiligen Zahlungsdienstleisters gelten.",
      "BriefAssist erhält dabei grundsätzlich nur diejenigen Zahlungsinformationen, die für die Zuordnung und Verwaltung des Vertrags erforderlich sind.",
    ],
  },
  {
    title: "12. Laufzeit und Verlängerung von Abonnements",
    body: [
      "Die jeweilige Laufzeit eines Abonnements ergibt sich aus dem bei Vertragsschluss ausgewählten Tarif.",
      "Sofern bei Abschluss ausdrücklich vereinbart, kann sich ein Abonnement automatisch verlängern.",
      "Der Nutzer wird vor Vertragsschluss über die jeweiligen Verlängerungs- und Kündigungsbedingungen informiert.",
    ],
  },
  {
    title: "13. Kündigung",
    body: [
      "Abonnements können entsprechend den bei Vertragsschluss angegebenen Bedingungen gekündigt werden.",
      "Die Kündigung kann insbesondere über die innerhalb der App bereitgestellten Funktionen erfolgen, sofern eine solche Funktion angeboten wird.",
      "Eine Kündigung beendet grundsätzlich die zukünftige Verlängerung des Abonnements. Bereits gezahlte Beträge werden nicht automatisch anteilig erstattet, soweit gesetzlich nichts anderes vorgeschrieben ist.",
      "Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.",
    ],
  },
  {
    title: "14. Widerrufsrecht für Verbraucher",
    body: [
      "Verbrauchern steht bei Fernabsatzverträgen grundsätzlich ein gesetzliches Widerrufsrecht zu.",
      "Einzelheiten ergeben sich aus der gesonderten Widerrufsbelehrung.",
      "Bei digitalen Leistungen kann das Widerrufsrecht unter den gesetzlichen Voraussetzungen vorzeitig erlöschen, insbesondere wenn der Verbraucher ausdrücklich zugestimmt hat, dass mit der Vertragsausführung vor Ablauf der Widerrufsfrist begonnen wird, und bestätigt hat, dass er dadurch sein Widerrufsrecht verlieren kann.",
    ],
  },
  {
    title: "15. Verfügbarkeit der App",
    body: [
      "Der Anbieter bemüht sich um eine möglichst hohe Verfügbarkeit von BriefAssist.",
      "Eine ununterbrochene oder vollständig fehlerfreie Verfügbarkeit kann jedoch nicht garantiert werden.",
      "Insbesondere können Wartungsarbeiten, technische Störungen, Ausfälle von Drittanbietern, Internetverbindungen oder andere außerhalb des Einflussbereichs des Anbieters liegende Umstände zu vorübergehenden Einschränkungen führen.",
    ],
  },
  {
    title: "16. Änderungen der App",
    body: [
      "Der Anbieter ist berechtigt, Funktionen von BriefAssist weiterzuentwickeln, anzupassen oder zu verändern, sofern dadurch die wesentlichen vertraglich vereinbarten Leistungen eines kostenpflichtigen Tarifs nicht unangemessen beeinträchtigt werden.",
      "Änderungen können insbesondere aus technischen, rechtlichen, sicherheitsrelevanten oder wirtschaftlichen Gründen erfolgen.",
    ],
  },
  {
    title: "17. Pflichten des Nutzers",
    body: [
      "Der Nutzer verpflichtet sich, BriefAssist nicht missbräuchlich zu verwenden.",
      "Untersagt sind insbesondere:",
    ],
    list: [
      "rechtswidrige Nutzung der App,",
      "das Hochladen illegaler Inhalte,",
      "Versuche, Sicherheitsmechanismen zu umgehen,",
      "automatisierte Zugriffe, die die Systeme übermäßig belasten,",
      "Reverse Engineering, soweit dies gesetzlich nicht ausdrücklich zulässig ist,",
      "die Nutzung zur Verletzung von Rechten Dritter.",
    ],
    footer: [
      "Bei erheblichen oder wiederholten Verstößen kann der Anbieter den Zugang vorübergehend sperren oder das Nutzerkonto kündigen.",
    ],
  },
  {
    title: "18. Rechte an der App",
    body: [
      "Sämtliche Rechte an BriefAssist, insbesondere an Software, Design, Marken, Logos, Texten und sonstigen eigenen Inhalten, verbleiben beim Anbieter oder den jeweiligen Rechteinhabern.",
      "Der Nutzer erhält lediglich ein einfaches, nicht übertragbares Recht zur Nutzung der App im Rahmen dieser AGB und des jeweils gebuchten Tarifs.",
    ],
  },
  {
    title: "19. Haftung",
    body: [
      "Der Anbieter haftet unbeschränkt für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit sowie für Schäden, die auf vorsätzlichem oder grob fahrlässigem Verhalten beruhen.",
      "Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten ist die Haftung auf den typischerweise vorhersehbaren Schaden begrenzt.",
      "Im Übrigen ist die Haftung bei leichter Fahrlässigkeit ausgeschlossen, soweit gesetzlich zulässig.",
      "Zwingende gesetzliche Haftungsvorschriften bleiben unberührt.",
      "Der Anbieter haftet insbesondere nicht für Schäden, die allein dadurch entstehen, dass ein Nutzer ungeprüft auf eine automatisierte Zusammenfassung, Übersetzung oder KI-basierte Einschätzung vertraut.",
    ],
  },
  {
    title: "20. Datenschutz",
    body: [
      "Die Verarbeitung personenbezogener Daten erfolgt nach den geltenden Datenschutzbestimmungen.",
      "Weitere Einzelheiten ergeben sich aus der gesonderten Datenschutzerklärung von BriefAssist.",
    ],
  },
  {
    title: "21. Sperrung und Beendigung des Nutzerkontos",
    body: [
      "Der Nutzer kann sein Nutzerkonto im Rahmen der angebotenen Funktionen löschen oder dessen Löschung beim Anbieter beantragen.",
      "Der Anbieter kann ein Nutzerkonto aus wichtigem Grund sperren oder kündigen, insbesondere bei erheblichen Verstößen gegen diese AGB oder bei missbräuchlicher Nutzung.",
      "Gesetzliche Aufbewahrungspflichten bleiben von einer Kontolöschung unberührt.",
    ],
  },
  {
    title: "22. Änderungen dieser AGB",
    body: [
      "Der Anbieter kann diese AGB ändern, wenn hierfür ein sachlicher Grund besteht, insbesondere aufgrund gesetzlicher Änderungen, technischer Weiterentwicklungen oder Veränderungen des Leistungsangebots.",
      "Über wesentliche Änderungen werden registrierte Nutzer in geeigneter Weise informiert.",
      "Änderungen, die das vertragliche Gleichgewicht erheblich zum Nachteil des Nutzers verändern, erfolgen nur im gesetzlich zulässigen Rahmen.",
    ],
  },
  {
    title: "23. Verbraucherstreitbeilegung",
    body: [
      "Der Anbieter ist nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
    ],
  },
  {
    title: "24. Anwendbares Recht",
    body: [
      "Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.",
      "Bei Verbrauchern gilt diese Rechtswahl nur insoweit, als dadurch zwingende Verbraucherschutzvorschriften des Staates des gewöhnlichen Aufenthalts des Verbrauchers nicht entzogen werden.",
    ],
  },
  {
    title: "25. Schlussbestimmungen",
    body: [
      "Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein oder werden, bleiben die übrigen Bestimmungen davon unberührt.",
      "An die Stelle unwirksamer Bestimmungen treten die gesetzlichen Vorschriften.",
    ],
  },
];

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="px-5 pt-4 pb-8" data-testid="terms-page">
      <button
        onClick={() => navigate(-1)}
        data-testid="terms-back"
        className="text-slate-600 flex items-center gap-1 text-sm mb-3"
      >
        <ArrowLeft className="w-4 h-4" /> Zurück
      </button>

      <h1 className="text-2xl font-bold text-slate-900">
        Allgemeine Geschäftsbedingungen (AGB)
      </h1>
      <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold mt-1">
        für BriefAssist
      </p>

      {SECTIONS.map((s, i) => (
        <section
          key={i}
          className="mt-5 rounded-2xl bg-white border border-slate-200 p-4"
          data-testid={`terms-section-${i + 1}`}
        >
          <h2 className="text-base font-semibold text-slate-900 mb-2">{s.title}</h2>
          <div className="text-[14px] text-slate-700 leading-relaxed space-y-2">
            {s.body.map((p, j) => <p key={j}>{p}</p>)}
            {s.list && (
              <ul className="list-disc pl-5 space-y-1">
                {s.list.map((li, k) => <li key={k}>{li}</li>)}
              </ul>
            )}
            {s.footer && s.footer.map((p, j) => <p key={`f${j}`}>{p}</p>)}
          </div>
        </section>
      ))}

      <p className="text-xs text-slate-500 mt-6" data-testid="terms-stand">
        Stand: August 2026
      </p>
    </div>
  );
}
